import * as t from "io-ts";
import nullable from "./nullable";
import { realOptional } from "./optional";
import { withFallback } from "io-ts-types";
export const deliveryRevisionChangedT = t.strict({
    deliveryId: t.string,
    revision: t.string,
});
export const createDeliveryTypes = ({ decimalT, }) => {
    const lineT = t.strict({
        id: t.string,
        productId: nullable(t.string),
        unitId: nullable(t.string),
        description: nullable(t.string),
        quantity: decimalT,
        amount: decimalT,
        date: t.string,
        locked: t.boolean,
        deferredInvoiceInvoiced: withFallback(nullable(t.boolean), null),
        status: t.union([
            t.literal("INVOICABLE"),
            t.literal("MISSING_PRODUCT"),
            t.literal("ALREADY_INVOICED"),
        ]),
        percentage: nullable(decimalT),
        discountPercentage: nullable(decimalT),
        isFromRoadToll: t.boolean,
        draftInvoiceNumber: nullable(t.string),
    });
    const updateInvoiceLineOrderNumberT = t.strict({
        orderNumber: t.number,
    });
    const createUpdateInvoiceLineT = t.type({
        productId: nullable(t.string),
        unitId: nullable(t.string),
        description: nullable(t.string),
        quantity: decimalT,
        amount: decimalT,
        discountPercentage: nullable(decimalT),
    });
    const computeInvoiceLinesOpT = t.union([
        t.type({ type: t.literal("ADD"), line: createUpdateInvoiceLineT }),
        t.type({
            type: t.literal("UPDATE"),
            id: t.string,
            line: createUpdateInvoiceLineT,
        }),
        t.type({
            type: t.literal("UPDATE_SURCHARGE"),
            id: t.string,
            percentage: decimalT,
        }),
        t.type({ type: t.literal("DELETE"), lineId: t.string }),
    ]);
    const computeInvoiceLinesRequestT = t.type({
        clientId: nullable(t.string),
        lines: t.array(lineT),
        op: computeInvoiceLinesOpT,
    });
    const expenseT = t.strict({
        id: t.string,
        accountId: t.string,
        date: t.string,
        amount: decimalT,
        currency: t.string,
        locked: t.boolean,
    });
    const deliveryT = t.type({
        id: t.string,
        revision: t.string,
        userId: nullable(t.string),
        orgId: t.string,
        clientId: nullable(t.string),
        customerContactId: nullable(t.string),
        invoiceRef: nullable(t.string),
        lines: t.array(lineT),
        expenses: t.array(expenseT),
        invoicable: t.boolean,
    });
    const deliveryUpdateResponseT = t.type({
        newLinesIds: t.array(t.string),
        delivery: deliveryT,
    });
    const updateSurchargeLineT = t.strict({
        percentage: decimalT,
    });
    const createUpdateExpenseT = t.strict({
        amount: decimalT,
        currency: t.string,
        accountId: t.string,
        date: t.string,
    });
    const sendInvoiceTypeT = t.union([
        t.literal("DIRECT"),
        t.literal("CONSOLIDATED"),
    ]);
    const sendInvoiceRequestT = t.strict({
        revision: t.string,
        lineIds: t.array(t.string),
        clientId: realOptional(t.string),
        dueDate: withFallback(nullable(t.string), null),
        customerContactId: realOptional(nullable(t.string)),
        departmentId: realOptional(nullable(t.string)),
        attachmentFileIds: realOptional(t.array(t.string)),
        folderName: realOptional(t.string),
        deliveryAddressId: realOptional(nullable(t.string)),
        type: sendInvoiceTypeT,
    });
    return {
        lineT,
        createUpdateInvoiceLineT,
        computeInvoiceLinesRequestT,
        expenseT,
        deliveryT,
        deliveryUpdateResponseT,
        updateSurchargeLineT,
        createUpdateExpenseT,
        sendInvoiceRequestT,
        sendInvoiceTypeT,
        updateInvoiceLineOrderNumberT,
    };
};
//# sourceMappingURL=deliveries.js.map